import { createFileRoute, redirect } from "@tanstack/react-router";

const allowedTabs = new Set(["payin", "optimus", "fx"]);

export const Route = createFileRoute(
  "/(app)/_admin-layout/admin_/merchants_/$merchantId/$tab",
)({
  component: () => null,
  beforeLoad: ({ params }) => {
    if (allowedTabs.has(params.tab)) {
      return;
    }
    throw redirect({
      to: "/admin/merchants/$merchantId",
      params: { merchantId: params.merchantId },
    });
  },
});
